import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/numberFormatter';
import { RowItems } from '../../models/TableProps';
import { LiveOrderDetailsData } from '../../models/LiveOrderProductProps';

export const LiveOrderProductsTableRow: React.FC<
    RowItems<LiveOrderDetailsData>
> = (props) => {
    const { row, index } = props;
    const { t } = useTranslation('liveOrders', {
        keyPrefix: 'LIVE_ORDER_DETAILS',
    });
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow hover key={labelId}>
            <TableCell id={labelId}>{row.itemCode}</TableCell>
            <TableCell>{row.description}</TableCell>
            <TableCell>
                {row.quantity} {t('QUANTITY_UNITS')}
            </TableCell>
            <TableCell>{formatPrice(row.netUnitPrice)} Ft</TableCell>
            <TableCell>{formatPrice(row.netLineAmount)} Ft</TableCell>
            <TableCell>{formatPrice(row.netUnitPrice * 1.27)} Ft</TableCell>
        </TableRow>
    );
};
